const en = {
  nav_gallery: "Gallery",
  nav_pricing: "Pricing",
  nav_b2b: "B2B",
  nav_contact: "Contact",
  nav_hours: "Hours: 10:00–18:00",
  nav_cta: "Get a Quote",
  nav_scroll_top: "Back to Top",

  hero_h1: "Restore Authentic Quality",
  hero_h2: "Protect Your Investment",
  hero_badge: "From 2 Days · Photo Quote in 10 Min",
  hero_delivery: "Nationwide Delivery",
  hero_speed: "Photo estimate replied within 10 min",
  hero_btn_gallery: "View Repair Gallery",
  hero_btn_pricing: "See Pricing",

  why_title: "Why Choose Us",
  why_subtitle: "Two unique strengths that set us apart from every other shop",
  why_speed_label: "Speed",
  why_speed_title: "Industry Fastest\n2-Day Turnaround",
  why_speed_desc: "Most competitors take at least a week. We complete repairs in as little as 2 days. Urgent requests are always accommodated — we never keep you waiting.",
  why_speed_other_label: "Other Shops",
  why_speed_other_val: "1 Week+",
  why_speed_us_label: "Our Turnaround",
  why_speed_us_val: "From 2 Days",
  why_quality_label: "Quality Warranty",
  why_quality_title: "30-Day Post-Repair\nQuality Warranty",
  why_quality_desc: "If any issue arises from normal use within 30 days of repair, we will restore it at no charge. Entrust your treasures with complete confidence.",
  why_quality_target_label: "Coverage",
  why_quality_target_val: "Normal Daily Use",
  why_quality_period_label: "Warranty Period",
  why_quality_period_val: "30 Days Post-Repair",

  gallery_label: "Repair Gallery",
  gallery_cta: "Request a Free Quote",
  gallery_repair_0: "Leather Scratch & Hole Repair",
  gallery_repair_1: "Exquisite Pattern Restoration",
  gallery_repair_2: "Hardware Re-plating",
  gallery_repair_3: "Surface Black Dyeing",
  gallery_repair_4: "Hardware Baked Coating Repair",
  gallery_repair_5: "Deep Stain Removal",

  pricing_label: "Pricing",
  pricing_title: "Repair Menu",
  pricing_subtitle: "Two flexible plans to suit every need",
  pricing_badge_flat: "No estimate · Flat rate",
  pricing_badge_no_extra: "No extra charge for complex repairs",
  pricing_pack_title: "Repair Packs",
  pricing_pack_popular: "Most Popular",
  pricing_pack_size_s: "Bag size up to 20cm",
  pricing_pack_size_m: "Bag size 20–30cm",
  pricing_pack_size_l: "Bag size 30–40cm",
  pricing_include_0: "Deep Cleanse",
  pricing_include_1: "Corner Repair (All Sides)",
  pricing_include_2: "Edge Paint Full Re-coat",
  pricing_include_3: "Handle Repair",
  pricing_include_4: "Logo Repair",
  pricing_include_5: "Hardware Polish",
  pricing_include_6: "Protective Coating",
  pricing_pack_cta: "Select This Plan",
  pricing_single_title: "À la Carte",
  pricing_single_subtitle: "Custom order by part",
  pricing_si_0: "Deep Cleanse",
  pricing_si_1: "Leather Restoration",
  pricing_si_2: "Edge Paint",
  pricing_si_3: "Black / Color Dyeing",
  pricing_si_4: "Interior Lining Repair",
  pricing_si_5: "Hardware Repair",
  pricing_si_6: "PVC Material Restoration",
  pricing_si_7: "Exquisite Pattern Restoration",
  pricing_si_8: "Enamel Repair",
  pricing_si_9: "Hardware Re-plating",
  pricing_note_1: "All prices are tax-inclusive. Final pricing may vary based on material condition and damage extent. Send a photo for a precise quote within 10 minutes.",
  pricing_note_2: "Other restoration services are also available. Our specialists will be happy to advise.",
  pricing_xl_title: "XL Sizes, Unusual Shapes & Luggage Welcome",
  pricing_xl_desc: "Items outside the S–L size range, unusual shapes, and suitcases are handled with individual quotations. Feel free to reach out anytime.",
  pricing_xl_cta: "Request Custom Quote",

  process_label: "How It Works",
  process_title: "Easy Mail-In Repair",
  process_subtitle: "Use our service from anywhere in the country, right from home",
  process_step_1_title: "Get in Touch",
  process_step_1_desc: "Contact us via LINE, WeCom, or email. Just send a photo to get started.",
  process_step_2_title: "Receive a Quote",
  process_step_2_desc: "We respond in as little as 10 minutes. No commitment until you approve the price.",
  process_step_2_badge: "10 min",
  process_step_3_title: "Ship Your Item",
  process_step_3_desc: "Once you approve, ship your item to our atelier. Please pack it carefully.",
  process_step_4_title: "Repair & Restore",
  process_step_4_desc: "Our master craftspeople restore your piece with care. Ready in as little as 2 days.",
  process_step_4_badge: "2 Days",
  process_step_5_title: "Receive It Back",
  process_step_5_desc: "We carefully pack your restored piece and ship it back for your inspection.",

  b2b_badge: "B2B",
  b2b_title: "For Resellers & Dealers:",
  b2b_highlight: " Exclusive Partner Program",
  b2b_desc: "A dedicated B2B program for second-hand luxury dealers and pawn shops. Elevate repair quality and streamline operations to sharpen your competitive edge.",
  b2b_stat_0_val: "50%",
  b2b_stat_0_label: "Faster Delivery",
  b2b_stat_0_sub: "vs. standard",
  b2b_stat_1_val: "From 2 Days",
  b2b_stat_1_label: "Fastest Turnaround",
  b2b_stat_1_sub: "B2B Priority Lane",
  b2b_stat_2_val: "30 Days",
  b2b_stat_2_label: "Warranty Period",
  b2b_stat_2_sub: "Free of charge",
  b2b_stat_3_val: "Nationwide",
  b2b_stat_3_label: "Service Area",
  b2b_stat_3_sub: "Mail-in accepted",
  b2b_benefit_0_title: "Deferred Payment",
  b2b_benefit_0_desc: "Use 10+ items/month to qualify for end-of-month consolidated invoicing. Manage cash flow with ease.",
  b2b_benefit_1_title: "Priority Lane",
  b2b_benefit_1_desc: "Partner orders are processed first, cutting standard lead time by up to 50%.",
  b2b_benefit_2_title: "Dedicated Account Manager",
  b2b_benefit_2_desc: "Your assigned manager handles progress updates and quality feedback in one place.",
  b2b_benefit_3_title: "Quality Control Reports",
  b2b_benefit_3_desc: "Detailed QC reports issued per item — ideal for customer-facing documentation.",
  b2b_target_label: "Perfect for",
  b2b_target_0: "Resale Shops & Pawnbrokers",
  b2b_target_1: "Luxury Consignment Dealers",
  b2b_target_2: "High-Volume Marketplace Sellers",
  b2b_target_3: "Department Stores & Boutiques",
  b2b_target_4: "Hotel & Concierge Services",
  b2b_cta_note: "Reach out anytime — our account team will walk you through everything.",
  b2b_cta_btn: "Apply for Partnership",

  contact_label: "Contact",
  contact_title: "Contact Us",
  contact_subtitle_1: "Photo estimate replied within 10 minutes",
  contact_subtitle_2: "Just send a photo to get started",
  contact_ch_0_name: "LINE Chat",
  contact_ch_0_target: "For customers in Japan",
  contact_ch_0_desc: "Add us on LINE and send a photo of your item. We will reply with a quote within 10 minutes.",
  contact_ch_1_name: "WeCom Chat",
  contact_ch_1_target: "For Chinese-speaking clients",
  contact_ch_1_desc: "We accept inquiries via WeCom. Feel free to message in Chinese anytime.",
  contact_ch_2_name: "Email",
  contact_ch_2_target: "For business clients",
  contact_ch_2_desc: "Business and dealer inquiries welcome via email. We respond promptly.",
  contact_logistics_1: "Nationwide mail-in service (shipping paid by customer)",
  contact_logistics_2: "Business hours: Weekdays 10:00–18:00",
  contact_mail_title: "Send Us an Email",
  contact_mail_desc: "Click below to open your email app. Including item photos, brand, and repair details helps us respond faster and more accurately.",
  contact_mail_tmpl_label: "Email Template",
  contact_mail_tmpl_0: "Your Name",
  contact_mail_tmpl_1: "Desired Service (Pack S / M / L, or à la carte)",
  contact_mail_tmpl_2: "Item Brand & Size",
  contact_mail_tmpl_3: "Repair Area & Requirements",
  contact_mail_tmpl_4: "Item Photos (attachment)",
  contact_mail_cta_btn: "Open Email App",
  contact_line_add_btn: "Add Friend on LINE",
  contact_wecom_add_btn: "Contact via WeCom",
  contact_mail_after: "Once we receive your photo, we will reply with a quote in as little as 10 minutes.",
  contact_mail_subject: "Repair Estimate Request",
  contact_mail_body: "Your Name:\nDesired Service:\nItem Brand & Size:\nRepair Area & Details:\n\nPlease attach photos of your item.",

  company_title: "Company Profile",
  ci_company: "Company",
  ci_rep: "Representative",
  ci_license: "Dealer License",
  ci_address: "Address",
  ci_hours: "Business Hours",
  ci_area: "Service Area",
  ci_brands: "Brands Handled",
  ci_email_label: "Email",
  ci_hours_val: "10:00–18:00 (Closed Sat / Sun / Holidays)",
  ci_area_val: "Nationwide (mail-in)",

  footer_band_delivery: "Nationwide Delivery",
  footer_band_speed: "Photo quote within 10 min",
  footer_band_hours: "Weekdays 10:00–18:00",
  footer_desc: "Restore authentic quality, protect your investment. Our Osaka-based atelier specializes in luxury bag restoration.",
  footer_services_title: "Services",
  footer_link_0: "Repair Packs",
  footer_link_1: "À la Carte",
  footer_link_2: "Gallery",
  footer_link_3: "B2B",
  footer_link_4: "Contact",
  footer_contact_title: "Contact",
  footer_sns_title: "Follow Us",
  footer_copyright: "© 2025 蔵新 OSAKA ATELIER. All rights reserved.",
  footer_privacy: "Privacy Policy",
  footer_law: "Legal Notice",
};

export default en;